import { lazy } from "react";

const MetaBookingReportLoadable = lazy(() => import("./BookingReport"));
const MetaDailyRecapReportLoadable = lazy(() => import("./DailyRecapReport"));
const MetaManifestChargeReportLoadable = lazy(() => import("./ManifestChargeReport"));
const MetaDpsPendingReportLoadable = lazy(() => import("./DpsPendingReport"));
const MetaDpsTodaysReleasedReportLoadable = lazy(() => import("./DpsTodaysReleasedReport"));
const MetaExceptionReportLoadable = lazy(() => import("./ExceptionReport"));
const MetaFuelManagementReportLoadable = lazy(() => import("./FuelManagementReport"));
const MetaPickingToOracleReportLoadable = lazy(() => import("./PickingToOracleReport"));
const MetaFirstMileReportLoadable = lazy(() => import("./OpAnalyticalReports/FirstMileReport"));
const MetaMiddleMileReportLoadable = lazy(() => import("./OpAnalyticalReports/MiddleMileReport"));
const MetaLastMileReportLoadable = lazy(() => import("./OpAnalyticalReports/LastMileReport"));
const MetaInTransitPendingReportLoadable = lazy(() => import("./OpAnalyticalReports/InTransitPendingReport"));
const MetaDriverTrackingHistoryReportLoadable = lazy(() => import("./DriverTrackingHistoryReport"));
const MetaTripPlanStatusReportLoadable = lazy(() => import("./OpAnalyticalReports/TripPlanStatusReport"));
const MetaBoxUtilizationReportLoadable = lazy(() => import("./OpAnalyticalReports/BoxUtilizationReport"));
const MetaCustomerShipperCoordinatesReportLoadable = lazy(() => import("./OpAnalyticalReports/CustomerShipperCoordinatesReport"));
const MetaCustomerConsigneeCoordinatesReportLoadable = lazy(() => import("./OpAnalyticalReports/CustomerConsigneeCoordinatesReport"));
const MetaFtlIdealVehicleReportLoadable = lazy(() => import("./OpAnalyticalReports/FTlIdealVehicleReport"));
const MetaDailyScanReportLoadable = lazy(() => import("./OpAnalyticalReports/DailyScanReport"));
const MetaFleetUtilizationReportLoadable = lazy(() => import("./OpAnalyticalReports/FleetUtilizationReport"));
const MetaVehicleUtilizationReportLoadable = lazy(() => import("./OpAnalyticalReports/VehicleUtilizationReport copy"));
const MetaBoxUtilizationByDateReportLoadable = lazy(() => import("./OpAnalyticalReports/BoxUtilizationByDate"));
const MetaSuspiciousScanReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaSuspiciousScanReport"));
const MetaEventAtHubScanReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaPickupDeliveryScanAtHubReport"));
const MetaBookingNationalAddressReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaAbsenceAndMissingShortAddressReport"));
const MetaOutOfLocationShipmentScanReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaOutOfLocationShipmentScanReport"));
const MetaCourierTripStopsReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaCourierTripStopsReport"));
const MetaIdleSeverityReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaIdleSeverityReport"));
const MetaShipperConsigneeWaitingTimeReportLoadable = lazy(() => import("./OpAnalyticalReports/MetaShipperConsigneeWaitingTimeReport"));
const MetaVehicleLoginAndLogoutDataLoadable = lazy(() => import("./OpAnalyticalReports/MetaVehicleLoginAndLogoutData"));
const MetaGpiFscImpactReportLoadable = lazy(() => import("./OpAnalyticalReports/GpiFscImpactReport"));
const MetaHandoverSheetReportLoadable = lazy(() => import("./OpAnalyticalReports/HandoverSheetReport"));
const MetaManifestConfirmationPendingReportLoadable = lazy(() => import("./OpAnalyticalReports/ManifestConfirmationPendingReport"));
const MetaAgreementReportLoadable = lazy(() => import("./OpAnalyticalReports/AgreementReport"));
const MetaPodReportLoadable = lazy(() => import("./OpAnalyticalReports/PodMetaReport"));
const MetaOnlinePaymentReportLoadable = lazy(() => import("./OnlinePaymentReport"));


export {
    MetaBookingReportLoadable,
    MetaDailyRecapReportLoadable,
    MetaManifestChargeReportLoadable,
    MetaDpsPendingReportLoadable,
    MetaDpsTodaysReleasedReportLoadable,
    MetaExceptionReportLoadable,
    MetaFuelManagementReportLoadable,
    MetaPickingToOracleReportLoadable,
    MetaFirstMileReportLoadable,
    MetaMiddleMileReportLoadable,
    MetaLastMileReportLoadable,
    MetaInTransitPendingReportLoadable,
    MetaDriverTrackingHistoryReportLoadable,
    MetaTripPlanStatusReportLoadable,
    MetaBoxUtilizationReportLoadable,
    MetaFtlIdealVehicleReportLoadable,
    MetaDailyScanReportLoadable,
    MetaFleetUtilizationReportLoadable,
    MetaVehicleUtilizationReportLoadable,
    MetaCustomerShipperCoordinatesReportLoadable,
    MetaCustomerConsigneeCoordinatesReportLoadable,
    MetaBoxUtilizationByDateReportLoadable,
    MetaSuspiciousScanReportLoadable,
    MetaEventAtHubScanReportLoadable,
    MetaBookingNationalAddressReportLoadable,
    MetaOutOfLocationShipmentScanReportLoadable,
    MetaCourierTripStopsReportLoadable,
    MetaIdleSeverityReportLoadable,
    MetaShipperConsigneeWaitingTimeReportLoadable,
    MetaVehicleLoginAndLogoutDataLoadable,
    MetaGpiFscImpactReportLoadable,
    MetaHandoverSheetReportLoadable,
    MetaManifestConfirmationPendingReportLoadable,
    MetaAgreementReportLoadable,
    MetaPodReportLoadable,
    MetaOnlinePaymentReportLoadable
};